module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Vonalkód jóváhagyás")]), _vm._v(" "), (_vm.requests.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('table', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.requests), function(request) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(request.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.request_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.groupname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('inputbox', {
      key: 'amount_' + request.id,
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "disabled": request.approved == 1,
        "errors": _vm.errors,
        "regexp_filter": "[0-9]+",
        "label": "",
        "id": 'amount_' + request.id
      },
      model: {
        value: (request.amount),
        callback: function($$v) {
          _vm.$set(request, "amount", $$v)
        },
        expression: "request.amount"
      }
    })], 1), _vm._v(" "), _c('td', _vm._l((request.access_levels), function(al) {
      return _c('checkbox', {
        attrs: {
          "disabled": request.approved == 1,
          "label": al.name,
          "id": 'alc_' + request.id + '_' + al.access_level_id
        },
        model: {
          value: (al.selected),
          callback: function($$v) {
            _vm.$set(al, "selected", $$v)
          },
          expression: "al.selected"
        }
      })
    }), 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.comment))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(request.approved == 0) ? _c('i', {
      staticClass: "fa fa-minus"
    }) : _vm._e(), _vm._v(" "), (request.approved == 1) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.approved_date))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [(request.approved == 0) ? _c('button', {
      staticClass: "small-button",
      attrs: {
        "title": "Igénylés jóváhagyása"
      },
      on: {
        "click": function($event) {
          return _vm.approve(request.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e(), _vm._v(" "), (request.approved == 0) ? _c('button', {
      staticClass: "small-button",
      attrs: {
        "title": "Igénylés törlése"
      },
      on: {
        "click": function($event) {
          return _vm.del(request.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })]) : _vm._e()])])
  })], 2)]) : _c('div', [_vm._v("\n          Nem található vonalkód igénylés.\n        ")])])]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Igénylés dátuma")]), _vm._v(" "), _c('th', [_vm._v("Csoport")]), _vm._v(" "), _c('th', [_vm._v("Mennyiség")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Engedély")]), _vm._v(" "), _c('th', [_vm._v("Megjegyzés")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Jóváhagyva")]), _vm._v(" "), _c('th', [_vm._v("Jóváhagyás dátuma")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577b5a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/barcode_approval.vue
// module id = 302
// module chunks = 0